import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import userManager from "./oidcConfig";

const ProtectedRoute = ({ element: Element }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        // Wait a bit for potential callback processing
        await new Promise((resolve) => setTimeout(resolve, 100));

        const user = await userManager.getUser();

        if (user && !user.expired && user.access_token) {
          setIsAuthenticated(true);
          setLoading(false);
        } else {
          console.log("No valid user found, redirecting to login");
          userManager.signinRedirect();
        }
      } catch (error) {
        console.error("Authentication check failed:", error);
        userManager.signinRedirect();
      }
    };

    checkAuthentication();
  }, [navigate]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "18px",
        }}
      >
        <div>
          <div>🔐 Verifying authentication...</div>
          <div style={{ fontSize: "14px", color: "#666", marginTop: "10px" }}>
            Please wait while we confirm your login status
          </div>
        </div>
      </div>
    );
  }

  return isAuthenticated ? <Element /> : null;
};

export default ProtectedRoute;
